(function () {
  var FREE_SHIP_CENTS = 4000;

  function safe(fn, fallback) {
    return function () {
      try {
        var result = fn.apply(null, arguments);
        return result === undefined ? fallback : result;
      } catch (error) {
        return fallback;
      }
    };
  }

  function toCents(value) {
    if (typeof value === 'number' && isFinite(value)) return value;
    if (typeof value === 'string') {
      var parsed = parseFloat(value.replace(/[^0-9.]/g, ''));
      if (isFinite(parsed)) return Math.round(parsed * 100);
    }
    return null;
  }

  function readCart() {
    var rebuy = window.Rebuy;
    if (!rebuy) return null;
    if (rebuy.SmartCart && rebuy.SmartCart.cart && typeof rebuy.SmartCart.cart.item_count === 'number') {
      return rebuy.SmartCart.cart;
    }
    if (rebuy.Cart && rebuy.Cart.cart && typeof rebuy.Cart.cart.item_count === 'number') {
      return rebuy.Cart.cart;
    }
    return null;
  }

  window.dpCart = {
    pillCount: safe(function (variantTitle) {
      if (typeof variantTitle !== 'string') return null;
      var match = variantTitle.match(/(\d+)\s*(pills?|ct|tablets?)/i);
      return match ? parseInt(match[1], 10) : null;
    }, null),

    variantLabel: safe(function (variantTitle) {
      if (typeof variantTitle !== 'string' || variantTitle === '' || variantTitle === 'Default Title') return null;
      if (/(\d+)\s*(pills?|ct|tablets?)/i.test(variantTitle)) {
        return 'Quantity: ' + variantTitle.replace(/(\d+)\s*ct/i, '$1 pills');
      }
      return variantTitle;
    }, null),

    itemVariantLabel: safe(function (item) {
      if (!item) return null;
      var title = item.variant_title;
      if (typeof title === 'string' && /(\d+)\s*(pills?|ct|tablets?)/i.test(title)) {
        return 'Quantity: ' + title.replace(/(\d+)\s*ct/i, '$1 pills');
      }
      var options = item.options_with_values;
      if (Array.isArray(options)) {
        var parts = options
          .filter(function (option) {
            return option && option.name !== 'Title' && option.value && option.value !== 'Default Title';
          })
          .map(function (option) { return option.name + ': ' + option.value; });
        if (parts.length) return parts.join(', ');
        if (options.length) return null;
      }
      if (typeof title === 'string' && title !== '' && title !== 'Default Title') return title;
      return null;
    }, null),

    perMealHTML: safe(function (priceCents, variantTitle) {
      var cents = toCents(priceCents);
      var pills = window.dpCart.pillCount(variantTitle);
      if (!cents || !pills) return null;
      var perPillCents = Math.floor(cents / pills);
      return '<b>$' + (perPillCents / 100).toFixed(2) + '</b> / dairy meal';
    }, null),

    optionCaption: safe(function (product, variant) {
      if (!variant || !variant.title || variant.title === 'Default Title') return null;
      var optionName = product && product.options && product.options[0] && (product.options[0].name || product.options[0]);
      if (typeof optionName === 'string' && optionName !== 'Title') {
        return optionName + ': ' + variant.title;
      }
      return variant.title;
    }, null),

    remapProgress: safe(function (percent, tierCount) {
      var p = parseFloat(percent);
      var n = parseInt(tierCount, 10);
      if (!isFinite(p) || !n || n < 1) return percent;
      var seg = 100 / n;
      var prevX = 0;
      var prevY = 0;
      for (var k = 0; k < n; k++) {
        var centerX = seg * (k + 0.5);
        var targetY = seg * (k + 1);
        if (p <= centerX) {
          return (prevY + ((p - prevX) / (centerX - prevX)) * (targetY - prevY)).toFixed(2) + '%';
        }
        prevX = centerX;
        prevY = targetY;
      }
      return '100%';
    }, null),

    highlightMoney: safe(function (text) {
      if (typeof text !== 'string') return text;
      if (/\$\d/.test(text)) {
        return text.replace(/(\$\d[\d,]*(?:\.\d{2})?)/, '<span class="dp-cart__money-accent">$1</span>');
      }
      return text.replace(/unlocked (.+)$/, 'unlocked <span class="dp-cart__money-accent">$1</span>');
    }, ''),

    noTrailingZeros: safe(function (money) {
      if (typeof money !== 'string') return money;
      return money.replace(/\.00(?=\D*$)/, '');
    }, ''),

    itemCountLabel: safe(function () {
      var cart = readCart();
      if (!cart) return 'Subtotal';
      var count = cart.item_count;
      return 'Subtotal (' + count + (count === 1 ? ' item' : ' items') + ')';
    }, 'Subtotal'),

    waitForSmartCart: safe(function (fallbackUrl) {
      var deadline = Date.now() + 12000;
      (function poll() {
        if (window.Rebuy && window.Rebuy.SmartCart && document.getElementById('rebuy-cart')) {
          try { window.Rebuy.SmartCart.show(); return; } catch (error) {}
        }
        if (Date.now() > deadline) {
          if (fallbackUrl) window.location = fallbackUrl;
          return;
        }
        setTimeout(poll, 150);
      })();
    }, undefined),

    shippingLabel: safe(function () {
      var cart = readCart();
      if (cart && typeof cart.items_subtotal_price === 'number' && cart.items_subtotal_price >= FREE_SHIP_CENTS) {
        return 'Free';
      }
      if (cart && typeof cart.total_price === 'number' && cart.total_price >= FREE_SHIP_CENTS) {
        return 'Free';
      }
      return 'Calculated at checkout';
    }, 'Calculated at checkout')
  };

  function renderBadge(count) {
    document.querySelectorAll('#cart-icon-bubble, .header__icon--cart').forEach(function (anchor) {
      var bubble = anchor.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          anchor.appendChild(bubble);
        }
        var visible = count < 100 ? '<span aria-hidden="true">' + count + '</span>' : '';
        bubble.innerHTML = visible + '<span class="visually-hidden">' + count + ' items</span>';
      } else if (bubble) {
        bubble.remove();
      }
    });
  }

  var badgeSyncTimer = null;

  function syncHeaderBadge(event) {
    try {
      var cart = (event && event.detail && event.detail.cart) || readCart();
      if (cart && typeof cart.item_count === 'number') {
        renderBadge(cart.item_count);
        return;
      }
      clearTimeout(badgeSyncTimer);
      badgeSyncTimer = setTimeout(function () {
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js')
          .then(function (response) { return response.json(); })
          .then(function (data) { renderBadge(data.item_count); })
          .catch(function () {});
      }, 300);
    } catch (error) {}
  }

  ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:cart.add'].forEach(function (type) {
    document.addEventListener(type, syncHeaderBadge);
  });

  try {
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
      var viewportMeta = document.querySelector('meta[name="viewport"]');
      if (viewportMeta && !/maximum-scale/.test(viewportMeta.content)) {
        viewportMeta.content += ', maximum-scale=1';
      }
    }
  } catch (error) {}

  document.addEventListener('click', function (event) {
    try {
      var link = event.target.closest('#cart-icon-bubble, a.header__icon--cart');
      if (!link) return;
      event.preventDefault();
      window.dpCart.waitForSmartCart(link.href);
    } catch (error) {}
  });

  document.addEventListener('click', function (event) {
    try {
      var btn = event.target.closest('.dp-cart__rec-add');
      if (btn && !btn.disabled) btn.classList.add('is-adding');
    } catch (error) {}
  });

  ['rebuy:cart.add', 'rebuy:cart.change'].forEach(function (type) {
    document.addEventListener(type, function () {
      try {
        document.querySelectorAll('.dp-cart__rec-add.is-adding').forEach(function (btn) {
          btn.classList.remove('is-adding');
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1500);
        });
      } catch (error) {}
    });
  });
})();
